<!-- Skip to main content link -->
<a href="#main-content" class="skip-link sr-only sr-only-focusable">Saltar al contenido principal</a>

<!-- Contenido principal -->
<main id="main-content" role="main">
  <!-- Hero Section -->
  <section class="hero-section" role="banner" aria-labelledby="hero-title">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="hero-content">
            <h1 id="hero-title" class="hero-title">Encuentra tu Próximo Desafío Profesional</h1>
            <p class="hero-description">
              Únete a nuestra plataforma y descubre oportunidades laborales que se adapten a tu perfil y aspiraciones profesionales.
            </p>
          </div>                   
        </div>
        <div class="col-lg-6">
          <div class="hero-content">
            <img src="assets/images/career-opportunities.jpg" alt="Personas trabajando en un entorno profesional moderno" class="hero-image" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Formulario de Postulación -->
  <section id="formulario" class="form-section" role="form" aria-labelledby="form-title">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="form-container">
            <h2 id="form-title" class="section-title">Formulario de Postulación</h2>
            <p class="section-description">
              Completa el formulario con tu información profesional y adjunta tu CV para comenzar tu proceso de postulación.
            </p>

            <!-- WebSocket Status Indicator - Solo mostrar si hay error -->
            <div class="websocket-status-indicator" *ngIf="websocketStatus.error">
              <div class="status-item error">
                <i class="fas fa-exclamation-triangle"></i>
                <span class="status-text">
                  ❌ Error de conexión: {{ websocketStatus.error }}
                </span>
              </div>
            </div>

            

            <!-- Paso 1: Registro Básico -->
            <div class="registration-step step-1" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
              <div class="step-header">
                <div class="step-number">1</div>
                <h3>Registro Básico</h3>
                <p>Completa tus datos básicos para crear tu cuenta</p>
              </div>

              <form [formGroup]="registrationForm" (ngSubmit)="executeRecaptchaAndSubmit()" *ngIf="currentStep === 1">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Email</mat-label>
                      <input 
                        matInput 
                        type="email" 
                        formControlName="email" 
                        placeholder="tu@email.com">
                      <mat-icon matSuffix matTooltip="Este será tu nombre de usuario para acceder a la plataforma">info_outline</mat-icon>
                      <mat-error *ngIf="getEmailControl()?.hasError('required')">
                        El email es requerido
                      </mat-error>
                      <mat-error *ngIf="getEmailControl()?.hasError('email')">
                        Ingresa un email válido
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Nombre</mat-label>
                      <input 
                        matInput 
                        type="text" 
                        formControlName="nombre" 
                        placeholder="Tu nombre">
                      <mat-icon matSuffix matTooltip="Tu nombre completo como aparece en documentos oficiales">info_outline</mat-icon>
                      <mat-error *ngIf="getNombreControl()?.hasError('required')">
                        El nombre es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Apellido</mat-label>
                      <input 
                        matInput 
                        type="text" 
                        formControlName="apellido" 
                        placeholder="Tu apellido">
                      <mat-icon matSuffix matTooltip="Tu apellido completo como aparece en documentos oficiales">info_outline</mat-icon>
                      <mat-error *ngIf="getApellidoControl()?.hasError('required')">
                        El apellido es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width phone-field">
                      <mat-label>Teléfono</mat-label>
                      <span matPrefix class="phone-prefix">+57&nbsp;</span>
                      <input 
                        matInput 
                        type="tel" 
                        formControlName="telefono" 
                        placeholder="300 123 4567">
                      <mat-icon matSuffix matTooltip="Número de contacto para coordinar entrevistas y comunicaciones importantes">info_outline</mat-icon>
                      <mat-error *ngIf="getTelefonoControl()?.hasError('required')">
                        El teléfono es requerido
                      </mat-error>
                      <mat-error *ngIf="getTelefonoControl()?.hasError('pattern')">
                        Ingresa exactamente 10 dígitos (ej: 300 123 4567)
                      </mat-error>
                      <mat-error *ngIf="getTelefonoControl()?.hasError('minlength')">
                        El teléfono debe tener al menos 10 dígitos
                      </mat-error>
                      <mat-error *ngIf="getTelefonoControl()?.hasError('maxlength')">
                        El teléfono debe tener máximo 10 dígitos
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Años de experiencia</mat-label>
                      <mat-select formControlName="experiencia">
                        <mat-option value="">Selecciona</mat-option>
                        <mat-option value="0-1">0-1 años</mat-option>
                        <mat-option value="1-2">1-2 años</mat-option>
                        <mat-option value="2-3">2-3 años</mat-option>
                        <mat-option value="3-5">3-5 años</mat-option>
                        <mat-option value="5-10">5-10 años</mat-option>
                        <mat-option value="10+">10+ años</mat-option>
                      </mat-select>
                      <mat-icon matSuffix matTooltip="Tiempo total trabajando en el área profesional. Incluye experiencia en empresas, proyectos freelance y prácticas profesionales">info_outline</mat-icon>
                      <mat-error *ngIf="getExperienciaControl()?.hasError('required')">
                        Los años de experiencia son requeridos
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Expectativa salarial</mat-label>
                      <mat-select formControlName="expectativaSalarial">
                        <mat-option value="">Selecciona</mat-option>
                        <mat-option value="Mínimo legal">Mínimo legal</mat-option>
                        <mat-option value="$2M - $3M">$2M - $3M</mat-option>
                        <mat-option value="$3M - $5M">$3M - $5M</mat-option>
                        <mat-option value="$5M - $8M">$5M - $8M</mat-option>
                        <mat-option value="Más de $8M">Más de $8M</mat-option>
                      </mat-select>
                      <mat-icon matSuffix matTooltip="Rango salarial mensual que esperas recibir. Los montos están en pesos colombianos (COP)">info_outline</mat-icon>
                      <mat-error *ngIf="getExpectativaSalarialControl()?.hasError('required')">
                        La expectativa salarial es requerida
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Modalidad de trabajo</mat-label>
                      <mat-select formControlName="modalidadTrabajo">
                        <mat-option value="">Selecciona</mat-option>
                        <mat-option value="Remoto">Remoto</mat-option>
                        <mat-option value="Híbrido">Híbrido</mat-option>
                        <mat-option value="Presencial">Presencial</mat-option>
                        <mat-option value="Flexible">Flexible</mat-option>
                      </mat-select>
                      <mat-icon matSuffix matTooltip="Forma en que prefieres trabajar: Remoto (desde casa), Híbrido (combinación), Presencial (en oficina) o Flexible (adaptable)">info_outline</mat-icon>
                      <mat-error *ngIf="getModalidadTrabajoControl()?.hasError('required')">
                        La modalidad de trabajo es requerida
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Disponibilidad</mat-label>
                      <mat-select formControlName="disponibilidad">
                        <mat-option value="">Selecciona</mat-option>
                        <mat-option value="Inmediata">Inmediata</mat-option>
                        <mat-option value="1-2 semanas">1-2 semanas</mat-option>
                        <mat-option value="1 mes">1 mes</mat-option>
                        <mat-option value="2-3 meses">2-3 meses</mat-option>
                        <mat-option value="A convenir">A convenir</mat-option>
                      </mat-select>
                      <mat-icon matSuffix matTooltip="Cuándo podrías comenzar a trabajar. 'Inmediata' significa que puedes empezar de inmediato, 'A convenir' permite negociar la fecha">info_outline</mat-icon>
                      <mat-error *ngIf="getDisponibilidadControl()?.hasError('required')">
                        La disponibilidad es requerida
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Tipo de discapacidad</mat-label>
                      <mat-select formControlName="discapacidad">
                        <mat-option value="">Selecciona</mat-option>
                        <mat-option value="Ninguna">Ninguna</mat-option>
                        <mat-option value="Física">Física</mat-option>
                        <mat-option value="Visual">Visual</mat-option>
                        <mat-option value="Auditiva">Auditiva</mat-option>
                        <mat-option value="Cognitiva">Cognitiva</mat-option>
                        <mat-option value="Psicosocial">Psicosocial</mat-option>
                        <mat-option value="Otra">Otra</mat-option>
                      </mat-select>
                      <mat-icon matSuffix matTooltip="Información para adaptar el entorno de trabajo a tus necesidades. Selecciona 'Otra' si tu discapacidad no está en la lista y especifica en el campo siguiente">info_outline</mat-icon>
                      <mat-error *ngIf="getDiscapacidadControl()?.hasError('required')">
                        El tipo de discapacidad es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" *ngIf="getDiscapacidadValue() === 'Otra'">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Especificar otra discapacidad</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="otraDiscapacidad"
                        placeholder="Especifica el tipo de discapacidad">
                      <mat-icon matSuffix matTooltip="Describe brevemente tu discapacidad para que podamos adaptar mejor el entorno de trabajo a tus necesidades específicas">info_outline</mat-icon>
                      <mat-error *ngIf="getOtraDiscapacidadControl()?.hasError('required')">
                        Debes especificar el tipo de discapacidad
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Comentarios adicionales</mat-label>
                  <textarea
                    matInput
                    formControlName="comentarios"
                    rows="3"
                    placeholder="Información adicional que consideres relevante"></textarea>
                  <mat-icon matSuffix matTooltip="Información adicional que consideres relevante para tu postulación: motivaciones, proyectos destacados, certificaciones especiales, o cualquier dato que quieras compartir">info_outline</mat-icon>
                </mat-form-field>

                                 <div class="form-group">
                   <label for="cvFile" class="form-label">
                     <strong>CV (PDF)</strong> <span class="text-danger">*</span>
                     <mat-icon class="text-info ms-1" matTooltip="Adjunta tu CV en formato PDF. Nuestra IA analizará automáticamente el contenido">info_outline</mat-icon>
                   </label>
                   <div class="file-upload-area" (click)="triggerFileSelection()">
                     <input 
                       type="file" 
                       id="cvFile"
                       accept=".pdf"
                       (change)="onFileSelected($event)"
                       style="display: none;">
                     <div class="file-upload-text" *ngIf="!selectedFile">
                       <i class="fas fa-cloud-upload-alt"></i>
                       <p>Arrastra tu CV aquí o haz clic para seleccionar</p>
                       <small>Formato permitido: PDF únicamente</small>
                     </div>
                     <div class="file-selected-info" *ngIf="selectedFile">
                       <i class="fas fa-file-pdf text-success"></i>
                       <p><strong>Archivo seleccionado:</strong> {{selectedFile.name}}</p>
                       <small>Tamaño: {{(selectedFile.size / 1024 / 1024).toFixed(2)}} MB</small>
                       <button mat-button color="warn" (click)="removeSelectedFile()" type="button">
                         <mat-icon>close</mat-icon> Cambiar archivo
                       </button>
                     </div>
                   </div>

                   <!-- Mensaje de ayuda para formato PDF -->
                   <div class="alert alert-info mt-2">
                     <mat-icon class="text-info">info</mat-icon>
                     <small>
                       <strong>Formato requerido:</strong> Solo archivos PDF (.pdf) de máximo 10MB. 
                       Nuestra IA analizará automáticamente el contenido para extraer información relevante.
                     </small>
                   </div>

                 </div>

                <div class="alert alert-info">
                  <mat-icon>security</mat-icon>
                  <small>La verificación de seguridad se ejecutará automáticamente al enviar el formulario</small>
                </div>

                <!-- Consentimiento para el tratamiento de datos -->
                <div class="consentimiento-container mb-3">
                  <mat-checkbox 
                    formControlName="consentimientoDatos"
                    color="primary"
                    class="consentimiento-checkbox"
                    required>
                    <span class="consentimiento-text">
                      <strong>Autorizo el tratamiento de mis datos personales</strong> para ser contactado por IncluTec y 
                      para el análisis de mi CV con inteligencia artificial. Entiendo que mis datos serán utilizados 
                      únicamente para fines de reclutamiento y selección laboral, en cumplimiento de la Ley 1581 de 2012 
                      y la Ley 2466 de 2023 sobre inclusión laboral de personas con discapacidad.
                    </span>
                  </mat-checkbox>
                  <mat-error *ngIf="getConsentimientoDatosControl()?.hasError('required') && getConsentimientoDatosControl()?.touched" 
                           class="consentimiento-error">
                    Debes aceptar el consentimiento para el tratamiento de datos para continuar
                  </mat-error>
                </div>

                <div class="form-actions">
                  <!-- Mensaje de validación -->
                                     <div class="alert alert-warning mb-3" *ngIf="!canSubmitForm() && registrationForm.touched">
                     <mat-icon>warning</mat-icon>
                     <small>
                       <strong>Para continuar necesitas:</strong>
                       <ul class="mb-0 mt-1">
                         <li *ngIf="!selectedFile">• Seleccionar un archivo CV</li>
                         <li *ngIf="getDiscapacidadValue() === 'Otra' && !(getOtraDiscapacidadControl() && getOtraDiscapacidadControl().value)">• Especificar el tipo de discapacidad</li>
                         <li *ngIf="!getConsentimientoDatosControl()?.value">• Aceptar el consentimiento para el tratamiento de datos</li>
                         <li *ngIf="registrationForm.invalid && getConsentimientoDatosControl()?.value">• Completar todos los campos obligatorios marcados con *</li>
                       </ul>
                     </small>
                   </div>
                  
                  <button 
                    mat-raised-button
                    color="primary"
                    class="submit-button"
                    type="submit"
                    [disabled]="!isReadyToClickSubmit() || isSubmitting || isExecutingRecaptcha"
                    [title]="getSubmitButtonTooltip()">
                    <mat-icon *ngIf="!isSubmitting && !isExecutingRecaptcha">send</mat-icon>
                    <span *ngIf="!isSubmitting && !isExecutingRecaptcha">Registrarme y recibir código de confirmación</span>
                    <mat-spinner *ngIf="isSubmitting || isExecutingRecaptcha" diameter="20"></mat-spinner>
                    <span *ngIf="isSubmitting">Procesando registro...</span>
                    <span *ngIf="isExecutingRecaptcha && !isSubmitting">Verificando seguridad...</span>
                  </button>
                </div>
              </form>
              
              <!-- Opción de login para usuarios ya registrados -->
              <div *ngIf="showLoginOption" class="login-option-container">
                <div class="alert alert-info">
                  <mat-icon>info</mat-icon>
                  <strong>¿Ya tienes cuenta?</strong> 
                  <p class="mb-2">Ya tienes una hoja de vida cargada en el sistema. Para actualizar tus datos o ver el análisis, debes autenticarte.</p>
                  <button 
                    mat-raised-button
                    color="accent"
                    (click)="goToLogin()"
                    class="mt-2">
                    <mat-icon>login</mat-icon>
                    Ir al Login
                  </button>
                </div>
              </div>
            </div>

            <!-- Paso 2: Confirmación y Contraseña -->
            <div class="registration-step step-2" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
              <div class="step-header">
                <div class="step-number">2</div>
                <h3>Confirmar Cuenta y Establecer Contraseña</h3>
                <p>Ingresa el código de confirmación enviado a tu email y establece tu contraseña</p>
              </div>

              <form [formGroup]="confirmationForm" (ngSubmit)="onConfirmationSubmit()" *ngIf="currentStep === 2">
                <div class="alert alert-info">
                  <mat-icon>info</mat-icon>
                  <strong>Revisa tu email:</strong> Se envió un código de confirmación a <strong>{{getEmailValue()}}</strong>
                </div>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Código de confirmación</mat-label>
                  <input 
                    matInput 
                    type="text" 
                    formControlName="confirmationCode" 
                    placeholder="123456"
                    maxlength="6">
                  <mat-error *ngIf="getConfirmationCodeControl()?.hasError('required')">
                    El código de confirmación es requerido
                  </mat-error>
                  <mat-error *ngIf="getConfirmationCodeControl()?.hasError('minlength')">
                    El código debe tener 6 dígitos
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Contraseña</mat-label>
                  <input 
                    matInput 
                    type="password" 
                    formControlName="password" 
                    placeholder="Tu contraseña"
                    autocomplete="new-password">
                  <mat-error *ngIf="getPasswordControl()?.hasError('required')">
                    La contraseña es requerida
                  </mat-error>
                  <mat-error *ngIf="getPasswordControl()?.hasError('minlength')">
                    Mínimo 8 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Confirmar contraseña</mat-label>
                  <input 
                    matInput 
                    type="password" 
                    formControlName="confirmPassword" 
                    placeholder="Confirma tu contraseña"
                    autocomplete="new-password">
                  <mat-error *ngIf="getConfirmPasswordControl()?.hasError('required')">
                    Confirma tu contraseña
                  </mat-error>
                  <mat-error *ngIf="getConfirmPasswordControl()?.hasError('passwordMismatch')">
                    Las contraseñas no coinciden
                  </mat-error>
                </mat-form-field>

                <div class="form-actions">
                  <button 
                    mat-button
                    color="accent"
                    (click)="goToStep(1)">
                    <mat-icon>arrow_back</mat-icon> Volver al paso anterior
                  </button>
                  <button 
                    mat-raised-button
                    color="primary"
                    type="submit"
                    [disabled]="confirmationForm.invalid || isConfirming">
                    <mat-icon *ngIf="!isConfirming">check_circle</mat-icon>
                    <span *ngIf="!isConfirming">Confirmar cuenta y establecer contraseña</span>
                    <mat-spinner *ngIf="isConfirming" diameter="20"></mat-spinner>
                    <span *ngIf="isConfirming">Confirmando...</span>
                  </button>
                </div>

                <div class="mt-3">
                  <button 
                    mat-button
                    color="primary"
                    (click)="resendConfirmationCode()"
                    [disabled]="isResending">
                    <mat-icon *ngIf="!isResending">refresh</mat-icon>
                    <span *ngIf="!isResending">Reenviar código de confirmación</span>
                    <mat-spinner *ngIf="isResending" diameter="16"></mat-spinner>
                    <span *ngIf="isResending">Reenviando...</span>
                  </button>
                </div>
              </form>
            </div>

                         <!-- Paso 3: Hoja de vida -->
             <div class="registration-step step-3" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
               <div class="step-header">
                 <div class="step-number">3</div>
                 <h3>Hoja de vida</h3>
                 <p>Tu CV ha sido almacenado en el sistema y será procesado automáticamente</p>
               </div>

               <div *ngIf="currentStep === 3">
                 <!-- Contenido del progreso (se muestra mientras procesa) -->
                 <div *ngIf="!analysisCompleted" class="process-content">
                   <div class="alert alert-success">
                     <mat-icon>check_circle</mat-icon>
                     <strong>CV almacenado exitosamente:</strong> {{selectedFile?.name}}
                     <br>
                     <small>Tamaño: {{selectedFile ? (selectedFile.size / 1024 / 1024).toFixed(2) : 0}} MB</small>
                   </div>

                   <div class="process-progress">
                     <!-- Indicador de sincronización en tiempo real -->
                     <div class="alert alert-info mb-3" *ngIf="currentCVStatus?.status === 'processing'">
                       <i class="fas fa-sync-alt fa-spin"></i>
                       <small>Sincronizando estado en tiempo real...</small>
                     </div>
                     
                     <div class="progress-item" [class.completed]="currentCVStatus?.progress >= 30">
                       <div class="progress-icon">
                         <i class="fas fa-user-check" *ngIf="currentCVStatus?.progress >= 30"></i>
                         <i class="fas fa-spinner fa-spin" *ngIf="currentCVStatus?.progress < 30"></i>
                       </div>
                       <div class="progress-text">
                         <h4>Registro completado</h4>
                         <p>Tu cuenta ha sido creada y confirmada exitosamente</p>
                       </div>
                     </div>

                     <div class="progress-item" [class.completed]="currentCVStatus?.progress >= 45">
                       <div class="progress-icon">
                         <i class="fas fa-upload" *ngIf="currentCVStatus?.progress >= 45"></i>
                         <i class="fas fa-spinner fa-spin" *ngIf="currentCVStatus?.progress < 45"></i>
                       </div>
                       <div class="progress-text">
                         <h4>Almacenamiento del CV</h4>
                         <p *ngIf="currentCVStatus?.progress < 45">Almacenando tu CV...</p>
                         <p *ngIf="currentCVStatus?.progress >= 45">✅ CV almacenado exitosamente</p>
                       </div>
                     </div>

                     <div class="progress-item" [class.completed]="currentCVStatus?.progress >= 60">
                       <div class="progress-icon">
                         <i class="fas fa-database" *ngIf="currentCVStatus?.progress >= 60"></i>
                         <i class="fas fa-spinner fa-spin" *ngIf="currentCVStatus?.progress < 60"></i>
                       </div>
                       <div class="progress-text">
                         <h4>Guardado del Perfil</h4>
                         <p *ngIf="currentCVStatus?.progress < 60">Guardando información del perfil...</p>
                         <p *ngIf="currentCVStatus?.progress >= 60">✅ Perfil guardado exitosamente</p>
                       </div>
                     </div>

                     <div class="progress-item" [class.completed]="currentCVStatus?.progress >= 90" [class.failed]="currentCVStatus?.status === 'failed'">
                       <div class="progress-icon">
                         <i class="fas fa-brain" *ngIf="currentCVStatus?.progress >= 90 && currentCVStatus?.status !== 'failed'"></i>
                         <i class="fas fa-exclamation-triangle" *ngIf="currentCVStatus?.status === 'failed'"></i>
                         <i class="fas fa-spinner fa-spin" *ngIf="currentCVStatus?.progress < 90 && currentCVStatus?.status !== 'failed'"></i>
                       </div>
                       <div class="progress-text">
                         <h4>Análisis Inteligente</h4>
                         <p *ngIf="currentCVStatus?.progress < 90 && currentCVStatus?.status !== 'failed'">Analizando tu CV con inteligencia artificial...</p>
                         <p *ngIf="currentCVStatus?.progress >= 90 && currentCVStatus?.status !== 'failed'">✅ Análisis de IA completado exitosamente</p>
                         <p *ngIf="currentCVStatus?.status === 'failed'" class="text-warning">⚠️ Análisis no pudo completarse</p>
                       </div>
                     </div>

                     <div class="progress-item" [class.completed]="currentCVStatus?.status === 'completed'">
                       <div class="progress-icon">
                         <i class="fas fa-check-circle" *ngIf="currentCVStatus?.status === 'completed'"></i>
                         <i class="fas fa-spinner fa-spin" *ngIf="currentCVStatus?.status !== 'completed'"></i>
                       </div>
                       <div class="progress-text">
                         <h4>Proceso completado</h4>
                         <p>Tu CV ha sido procesado exitosamente</p>
                       </div>
                     </div>
                   </div>

                   <!-- Indicador de progreso en tiempo real -->
                   <div class="realtime-progress mt-4" *ngIf="currentCVStatus">
                     <div class="progress-bar-container">
                       <div class="progress-bar" [style.width.%]="currentCVStatus.progress || 0"></div>
                     </div>
                     <div class="progress-text">
                       <mat-icon *ngIf="currentCVStatus.status === 'processing'" class="spinning">sync</mat-icon>
                       <mat-icon *ngIf="currentCVStatus.status === 'completed'" class="success">check_circle</mat-icon>
                       <mat-icon *ngIf="currentCVStatus.status === 'failed'" class="warning">warning</mat-icon>
                       <span>{{currentCVStatus.step || 'Procesando...'}}</span>
                       <span class="progress-percentage" *ngIf="currentCVStatus.progress > 0">({{currentCVStatus.progress}}%)</span>
                     </div>
                   </div>
                 </div>

                 <!-- Resultado del análisis (se muestra cuando se completa) -->
                 <div *ngIf="analysisCompleted" class="analysis-result-content">
                   <div class="analysis-result-card">
                     <div class="result-header">
                       <div class="result-icon">
                         <i class="fas fa-check-circle success-icon" *ngIf="!analysisFailed"></i>
                         <i class="fas fa-exclamation-triangle warning-icon" *ngIf="analysisFailed"></i>
                       </div>
                       <h3 class="result-title">
                         {{ analysisFailed ? '🎯 Proceso Completado' : '🎯 Resultado del Análisis Inteligente' }}
                       </h3>
                     </div>
                     
                     <div class="result-body">
                       <div *ngIf="analysisFailed" class="failure-message">
                         <div class="message-item">
                           <strong>Estado:</strong> ✅ Tu CV ha sido guardado exitosamente en nuestro sistema
                         </div>
                         <div class="message-item">
                           <strong>Análisis automático:</strong> ⚠️ No se pudo completar el análisis inteligente automático
                         </div>
                         <div class="message-item">
                           <strong>Próximo paso:</strong> 🚀 Nos pondremos en contacto contigo tan pronto tengamos oportunidades laborales que se ajusten a tu perfil
                         </div>
                         <div class="message-item">
                           <strong>Tu información está segura:</strong> 🔒 Todos tus datos han sido almacenados correctamente
                         </div>
                       </div>
                       
                       <div *ngIf="!analysisFailed && hasAnalysisResults" class="success-message">
                         <div class="message-item">
                           <strong>Perfil Profesional:</strong> {{currentAnalysisResult.perfil_profesional || 'No especificado'}}
                         </div>
                         <div class="message-item">
                           <strong>Estado del CV:</strong> <span class="status-{{currentAnalysisResult.estado_cv?.toLowerCase() || 'no-evaluado'}}">{{currentAnalysisResult.estado_cv || 'No especificado'}}</span> - Puntuación: {{currentAnalysisResult.puntuacion_general || 0}}/10
                         </div>
                         <div class="message-item">
                           <strong>Fortalezas Destacadas:</strong> {{currentAnalysisResult.fortalezas_destacadas?.join(', ') || 'No especificadas'}}
                         </div>
                         <div class="message-item">
                           <strong>Áreas de Mejora:</strong> {{currentAnalysisResult.areas_mejora?.join(', ') || 'No especificadas'}}
                         </div>
                         <div class="message-item">
                           <strong>Recomendaciones:</strong> {{currentAnalysisResult.recomendaciones_cv?.join(', ') || 'No especificadas'}}
                         </div>
                         <div class="message-item">
                           <strong>Estado:</strong> ✅ Análisis completado exitosamente
                         </div>
                         <div class="message-item">
                           <strong>Próximo paso:</strong> 🚀 Te contactaremos pronto con oportunidades laborales
                         </div>
                       </div>
                     </div>
                     
                     <div class="result-footer">
                       <button mat-raised-button color="primary" class="btn-continue" (click)="goToNextStep()">
                         <i class="fas fa-arrow-right"></i>
                         Continuar
                       </button>
                     </div>
                   </div>
                 </div>
               </div>
             </div>


          </div>
        </div>
      </div>
    </div>

    <!-- reCAPTCHA global para todo el proceso -->
    <re-captcha 
      #recaptcha
      [siteKey]="recaptchaSiteKey" 
      (resolved)="onRecaptchaResolved($event)"
      size="invisible"
      [useGlobalDomain]="false">
    </re-captcha>
  </section>

  <!-- Sección de Rutas de Formación -->
  <section class="training-section" role="region" aria-labelledby="training-title">
    <div class="container">
      <h2 id="training-title" class="section-title">Rutas de Formación</h2>
      <p class="section-description">
        Desarrolla tus habilidades con nuestros programas de formación especializados.
      </p>
      
      <div class="row">
        <div class="col-lg-4 col-md-6" *ngFor="let ruta of rutasFormacion; let i = index">
          <div class="training-card" role="article" [attr.aria-labelledby]="'ruta-' + i + '-title'">
            <div class="card-header">
              <h3 id="ruta-{{ i }}-title" class="training-title">{{ ruta.rol }}</h3>
            </div>
            <div class="card-body">
              <p class="training-description">{{ ruta.descripcion }}</p>
              <div class="training-details">
                <div class="detail-item">
                  <i class="fas fa-calendar-alt" aria-hidden="true"></i>
                  <span>Duración: {{ ruta.duracion }}</span>
                </div>
                <div class="detail-item">
                  <i class="fas fa-graduation-cap" aria-hidden="true"></i>
                  <span>Modalidad: {{ ruta.modalidad }}</span>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button 
                type="button" 
                class="btn btn-outline-primary btn-sm"
                (click)="inscribirseRuta(ruta)"
                [attr.aria-label]="'Inscribirse en ' + ruta.rol">
                <i class="fas fa-user-plus" aria-hidden="true"></i>
                <span>Inscribirse</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección FAQ -->
  <section class="faq-section" role="region" aria-labelledby="faq-title">
    <div class="container">
      <h2 id="faq-title" class="section-title">Preguntas Frecuentes</h2>
      <p class="section-description">
        Resolvemos las dudas más comunes sobre nuestro proceso de selección.
      </p>
      
      <div class="faq-container">
        <div class="faq-item" *ngFor="let item of faq; let i = index" role="article">
          <button 
            type="button" 
            class="faq-question"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="item.expanded"
            [attr.aria-controls]="'faq-answer-' + i"
            [attr.aria-label]="'Pregunta ' + (i + 1) + ': ' + item.pregunta">
            <span class="question-text">{{ item.pregunta }}</span>
            <i class="fas" [class.fa-chevron-down]="!item.expanded" [class.fa-chevron-up]="item.expanded" aria-hidden="true"></i>
          </button>
          <div 
            id="faq-answer-{{ i }}"
            class="faq-answer"
            [class.show]="item.expanded"
            role="region"
            [attr.aria-labelledby]="'faq-question-' + i">
            <p>{{ item.respuesta }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- Botón de volver arriba -->
<button 
  type="button" 
  class="btn btn-primary back-to-top-left"
  (click)="scrollToTop()"
  aria-label="Volver arriba"
  title="Volver arriba">
  <i class="fas fa-arrow-up" aria-hidden="true"></i>
  <span class="sr-only">Volver arriba</span>
</button>
